import { enqueueSnackbar } from "notistack";
import * as requestFromServer from "./rechargeLinesCrud";
import {rechargeLinesSlice, callTypes} from "./rechargeLinesSlice";

const {actions} = rechargeLinesSlice;

export const fetchMyRechargeLines = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findMyRechargeLines(queryParams)
    .then(response => {
      const { rechargeLinesList } = response.data;
      dispatch(actions.myRechargeLinesFetched({ rechargeLinesList }));
    })
    .catch(error => {
      error.clientMessage = "Can't find rechargeLines";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchHistoryPrepaidRecharge = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findHistoryPrepaidRecharge(queryParams)
    .then(response => {
      const { list } = response.data;
      dispatch(actions.historyPrepaidRechargeFetched({ list }));
    })
    .catch(error => {
      error.clientMessage = "Can't find rechargeLines";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const updateRechargeLinesStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForRechargeLines(ids, status)
    .then(() => {
      dispatch(actions.rechargeLinesStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const rechargeScratchCard = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .rechargeScratchCardd(params)
    .then(response => {
      const { statusCode } = response.data;
      dispatch(actions.scratchCardRecharged({  }));
      if (statusCode.code == 0) enqueueSnackbar(statusCode.message,{ 
        variant:  "success"
      });
      else enqueueSnackbar(statusCode.message, { 
        variant:  "warning"
      });
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const rechargePrePaid = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .rechargePrePaid(params)
    .then(response => {
      const { statusCode,url } = response.data;
      dispatch(actions.prePaidRecharged({  }));
      
      url && window.open(url, '_blank')
      if (statusCode.code == 0) enqueueSnackbar(statusCode.message,{ 
        variant:  "success"
      });
      else enqueueSnackbar(statusCode.message, { 
        variant:  "warning"
      });
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const fetchLoansDetails = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findLoansDetails(queryParams)
    .then(response => {
      const { loans ,autoLoanEnabled,messageDescription} = response.data;
      dispatch(actions.loansDetailsFetched({ loans ,autoLoanEnabled,messageDescription }));
    })
    .catch(error => {
      error.clientMessage = "Can't find rechargeLines";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const applyLoan = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .applyLoan(params)
    .then(response => {
      const { statusCode } = response.data;
      dispatch(actions.loanApplied({ statusCode }));
      
      if (statusCode.code == 0) enqueueSnackbar(statusCode.message,{ 
        variant:  "success"
      });
      else enqueueSnackbar(statusCode.message, { 
        variant:  "warning"
      });
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const autoCreditLoan = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .autoCreditLoan(params)
    .then(response => {
      const { statusCode } = response.data;
      dispatch(actions.autoCreditLoanDone({ statusCode }));
      
      if (statusCode.code == 0) enqueueSnackbar(statusCode.message,{ 
        variant:  "success"
      });
      else enqueueSnackbar(statusCode.message, { 
        variant:  "warning"
      });
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const rechargeNasPaid = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .rechargeNasPaid(params)
    .then(response => {
      const { statusCode,url ,description} = response.data;
      dispatch(actions.nasPaidRecharged({ }));
      url && window.open(url, '_blank')
      if (statusCode.code == 0) {
        enqueueSnackbar(statusCode.message,{ 
        variant:  "success"
      });
      }
      else if(statusCode.code == 977){
         enqueueSnackbar(statusCode.message,{ 
        variant:  "success"
         });
      }
      else enqueueSnackbar(description, { 
        variant:  "warning"
      });
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const GetNasPaidStatus = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .NasPaidStatus(params)
    .then(response => {
      const { statusCode,title ,statusType} = response.data;
      dispatch(actions.nasPaidStatus({  }));
      if (statusType == 984) enqueueSnackbar(title,{ 
        variant:  "success"
      });
      else enqueueSnackbar(title, { 
        variant:  "warning"
      });
    })
    .catch(error => {
      error.clientMessage = "Can't update rechargeLines status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


